import React from 'react';
import Moment from 'moment';
import MomentLocalizer from 'react-widgets-moment';
import PropTypes from 'prop-types';
import { DatePicker as DTP, Localization } from 'react-widgets';
import Theme from "./Theme.js";
import { jsx as _jsx } from "react/jsx-runtime";
const localizer = MomentLocalizer.default ? new MomentLocalizer.default(Moment) : new MomentLocalizer(Moment);

/** 
 * React class that renders a date time picker
 * @see {@link https://jquense.github.io/react-widgets/api/DateTimePicker/} 
 * @property {string} timezone
 * @property {string} variant - Theme variant name to be added to the component
 * @property {string} className - css class to be applied to this component
 * @property {any} eventData - will be passed through as the data key to the onClick function
 * @property {function} onChange - function to be called when the button is clicked
 * */
class DateTimePicker extends React.Component {
  static contextType = Theme.Context;
  static propTypes = {
    timezone: PropTypes.string,
    variant: PropTypes.string,
    className: PropTypes.string,
    eventData: PropTypes.any,
    children: PropTypes.node,
    includeTime: PropTypes.bool
  };
  static defaultProps = {
    timezone: null,
    variant: null,
    className: null,
    eventData: null,
    children: null,
    includeTime: true
  };
  static getDerivedStateFromProps(props) {
    let type = null;
    if (props && props.value) {
      type = props.value instanceof Date ? 'date' : typeof props.value;
    }
    return {
      valueType: type
    };
  }
  constructor(props) {
    super(props);
    const {
      timezone
    } = this.props;
    if (timezone != null) {
      Moment.locale(timezone);
    } else {
      Moment.locale('utc');
    }
    this.state = {};
  }

  /**
   * (Internal) event that gets fired whenever the user makes a selection on the widget
   */
  onSelect = value => {
    let toSend = value;
    const {
      onChange,
      eventData
    } = this.props;
    const {
      valueType
    } = this.state;
    // don't know what this was supposed to do, ignoring
    switch (valueType) {
      case 'string':
        toSend = toSend.toISOString();
        break;
      case 'number':
        toSend = toSend.getTime();
        break;
      default:
        break;
    }
    if (typeof onChange === 'function') {
      onChange({
        value: toSend,
        data: eventData
      });
    }
  };
  render() {
    const theme = this.context;
    const {
      className,
      eventData,
      onChange,
      variant,
      value,
      layoutOptions,
      ...rest
    } = theme.props('DateTimePicker', this.props); // eslint-disable-line

    if (Object.keys(this.props).includes('value') && value !== undefined && value !== null) {
      rest.value = new Date(value);
    }
    return /*#__PURE__*/_jsx(Localization, {
      date: localizer,
      children: /*#__PURE__*/_jsx(DTP, {
        onChange: this.onSelect,
        className: theme.classes('DateTimePicker', 'dateTimePicker', variant, className),
        format: "YYYY-MM-DDTHH:mm:ss.SSS",
        ...rest
      })
    });
  }
}
export default DateTimePicker;